import { useCallback, useState } from "react";
import useAdminLoad from "../../../hooks/useAdminLoad";
import * as crmApi from "../api/crmApi";

/**
 * The practice's saved views (shared by owner and helpers: the worked example's helper
 * reopens "Workshop invitees" next month and it recalculates live).
 */
export default function useSavedViews() {
  const [views, setViews] = useState([]);
  const load = useCallback(async () => {
    const page = await crmApi.listViews();
    setViews(Array.isArray(page?.rows) ? page.rows : []);
  }, []);
  const { loading, loadError, reload } = useAdminLoad(load);

  const save = useCallback(async (name, filters, sort) => {
    // A view's `sort` is the structured `{field, dir}` (contract v1.8); the list query spells
    // it as the separate `sort` + `dir` params (useClientFilters.applyView maps it back).
    const view = await crmApi.createView({ name, filters, sort: { field: sort.field, dir: sort.dir } });
    setViews((v) => [...v, view].sort((a, b) => a.name.localeCompare(b.name)));
    return view;
  }, []);

  const remove = useCallback(async (id) => {
    await crmApi.deleteView(id);
    setViews((v) => v.filter((x) => x.id !== id));
  }, []);

  return { views, loading, loadError, reload, save, remove };
}
